import { v4 as createUUID } from "uuid";

import coinflip from "@atlassian/wac-coinflip";
import { getInteractionRate } from "@atlassian/wac-ufo-config";
import { getActiveTrace } from "@atlassian/wac-ufo-experience-trace-id-context";
import { DefaultInteractionID } from "@atlassian/wac-ufo-interaction-id-context";
import { addNewInteraction } from "@atlassian/wac-ufo-interaction-metrics";
import init from "@atlassian/wac-ufo-interaction-metrics-init";
import UFORouteName from "@atlassian/wac-ufo-route-name-context";

// REMOVED
// import { initUFOBeforePageLoadStart } from "./feature-flags";

export let pageLoadInteractionId = "";

export default function traceUFOPageLoad(
    ufoName: string | null | undefined,
    routeName: string | null | undefined = ufoName
) {
    // REMOVED
    // if (initUFOBeforePageLoadStart()) {
    //     init();
    // }
    init();
    if (ufoName != null) {
        UFORouteName.current = ufoName;
        const rate = getInteractionRate(ufoName, "page_load");
        if (coinflip(rate)) {
            const newId: string = createUUID();
            DefaultInteractionID.current = newId;
            addNewInteraction(
                newId,
                ufoName,
                "page_load",
                0,
                rate,
                null,
                routeName,
                getActiveTrace()
            );
            pageLoadInteractionId = newId;
        }
    }

    // REMOVED
    // if (!initUFOBeforePageLoadStart()) {
    //     init();
    // }
}
